(function () {
  const stickyATC = document.querySelector('.nextdev--sticky-atc-button');
  const stickyATCOverlay = document.querySelector('.nextdev--sticky-atc-button__overlay');
  let variants = stickyATC.querySelector('[type="application/json"]');
  if (variants != null) variants = JSON.parse(variants.textContent);
  const selects = stickyATC.querySelectorAll('.nextdev--sticky-atc-button__product-options select');
  const options = stickyATC.querySelectorAll('.nextdev--sticky-atc-button__product-options select option');
  const isEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);
  const button = stickyATC.querySelector('.nextdev--sticky-atc-button__product-button');
  const btn = button.querySelector('button');
  const btnContent = btn.querySelector('.button--content');
  const btnLoading = btn.querySelector('.loading-overlay__spinner');
  const variant_id = button.querySelector('input[name="id"]');
  const image = stickyATC.querySelector('.nextdev--sticky-atc-button__product-image');
  const mobileImage = stickyATC.querySelector('.nextdev--sticky-atc-button__product-image__mobile');
  const mobileContainer = stickyATC.querySelector('.nextdev--sticky-atc-button__mobile');
  const mobileOptionsLabel = mobileContainer.querySelector('.nextdev--sticky-atc-button__product-options__mobile--selected_options');
  const mobileOptionsToggle = mobileContainer.querySelector('.nextdev--sticky-atc-button__product-options__mobile--change_options a');
  const mobileOptions = mobileContainer.querySelectorAll('.nextdev--sticky-atc-button__product-options__mobile--options input[type="radio"]');
  const productForm = document.querySelector('.product-form');
  let productFormOptions = [];
  let productInfo = productForm.closest('.product__info-container');
  if (productInfo != null) {
    productFormOptions = productInfo.querySelectorAll('fieldset input[type="radio"]');
  } else {
    productInfo = productForm.closest('.nextdev--pdp-main--info');
    productFormOptions = productInfo.querySelectorAll('.nextdev--pdp-main--info__options input[type="radio"]');
  }
  

  document.addEventListener('DOMContentLoaded', () => {
    if (productForm != null) {
      const productFormPosition = productInfo.offsetTop + productInfo.offsetHeight;

      window.addEventListener('scroll', () => {
        if (window.scrollY >= productFormPosition) {
          document.body.classList.add('sticky-atc');
          stickyATC.classList.remove('hidden');
        } else {
          document.body.classList.remove('sticky-atc');
          stickyATC.classList.add('hidden');
        }
      });
      }

      if (mobileOptionsToggle != null) {
      mobileOptionsToggle.addEventListener('click', (e) => {
        e.preventDefault();

        mobileContainer.classList.toggle('show');
        stickyATCOverlay.classList.toggle('hidden');

        mobileOptionsToggle.textContent = (mobileContainer.classList.contains('show') ? 'Hide Options' : 'Change Options');
      });

      stickyATCOverlay.addEventListener('click', (e) => {
        mobileContainer.classList.remove('show');
        stickyATCOverlay.classList.add('hidden');
        mobileOptionsToggle.textContent = 'Change Options';
      });

      mobileOptions.forEach((mobileOption) => {
        const mobileOptionLabel = mobileOption.closest('.nextdev--sticky-atc-button__product-options__mobile--option').querySelector('.nextdev--sticky-atc-button__product-options__mobile--option_selected');

        mobileOption.addEventListener('change', () => {
          mobileOptionLabel.textContent = mobileOption.value;

          let selectedOptions = [];
          mobileContainer.querySelectorAll('.nextdev--sticky-atc-button__product-options__mobile--options input[type="radio"]:checked').forEach((selectedOption) => {
            selectedOptions.push(selectedOption.value);
          });

          mobileOptionsLabel.textContent = selectedOptions.join(' / ');

          selectedOptions.forEach((selectedOption) => {
            options.forEach((option) => {
              if (option.value == selectedOption && option.selected == false) {
                option.selected = true;
                option.closest('select').dispatchEvent(new Event('change', { bubbles: true }));
              }
            });
          });
        });
      });
    }
  });

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    selects.forEach((select) => {
      select.disabled = true;
      select.parentElement.querySelector('button').disabled = true;
    });

    btn.disabled = true;
    btnContent.classList.add('hidden');
    btnLoading.classList.remove('hidden');

    if (productFormOptions != null) {
      productForm.querySelector('form .product-form__submit').click();
    }
  });

  const customSelects = stickyATC.querySelectorAll('select.js-custom-select-atc');
  customSelects.forEach(enhanceSelect);

  function enhanceSelect(nativeSelect) {
    const id = nativeSelect.id || `select-${Math.random().toString(36).slice(2)}`;
    nativeSelect.id = id;

    const wrapper = document.createElement('div');
    wrapper.className = 'c-select';
    nativeSelect.after(wrapper);

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'c-select__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');

    const chev = document.createElement('span');
    chev.className = 'c-select__chev';
    chev.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    const btnText = document.createElement('span');
    btnText.innerHTML = textForValue(nativeSelect);
    button.append(btnText, chev);

    const listbox = document.createElement('ul');
    listbox.className = 'c-select__list';
    listbox.id = `${id}-listbox`;
    listbox.setAttribute('role', 'listbox');
    listbox.setAttribute('tabindex', '-1');
    listbox.hidden = true;

    button.setAttribute('aria-controls', listbox.id);

    const optionEls = [];
    Array.from(nativeSelect.options).forEach((opt, idx) => {
      const li = document.createElement('li');
      li.className = 'c-select__option';
      li.setAttribute('role', 'option');
      li.setAttribute('data-value', opt.value);
      
      const image = opt.dataset.image;
      if (image != undefined) {
        li.innerHTML = '<img src="' + image + '" alt="' + opt.textContent + '" width="20" height="20" loading="lazy">\
        <span>' + opt.textContent + '</span>';
      } else {
        li.textContent = opt.textContent;
      }

      if (opt.disabled) li.setAttribute('aria-disabled', 'true');
      if (opt.selected) li.setAttribute('aria-selected', 'true');
      
      li.tabIndex = -1;

      li.addEventListener('click', () => selectValue(opt.value, { focusButton: true }));
      li.addEventListener('mousedown', (e) => { e.preventDefault(); });

      optionEls.push(li);
      listbox.appendChild(li);
    });

    wrapper.append(button, listbox);

    nativeSelect.classList.add('c-select--hidden');
    wrapper.prepend(nativeSelect);

    function openList({ focusOption = true } = {}) {
      if (!listbox.hidden) return;
      listbox.hidden = false;
      button.setAttribute('aria-expanded', 'true');

      if (focusOption) {
        const current = listbox.querySelector('[aria-selected="true"]') || nextEnabled(optionEls[0], +1);
        if (current) current.focus();
      }
      document.addEventListener('mousedown', onDocClick);
      document.addEventListener('focusin', onDocFocusOut);
      document.addEventListener('keydown', onDocTypeahead);
    }

    function closeList({ returnFocus = true } = {}) {
      if (listbox.hidden) return;
      listbox.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      if (returnFocus) button.focus();
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('focusin', onDocFocusOut);
      document.removeEventListener('keydown', onDocTypeahead);
      typeBuffer = '';
    }

    function selectValue(value, { focusButton = false, fire = true } = {}) {
      nativeSelect.value = value;
      if (fire) nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));

      optionEls.forEach(li => li.setAttribute('aria-selected', String(li.dataset.value === value)));
      btnText.innerHTML = textForValue(nativeSelect);

      closeList({ returnFocus: focusButton });
    }

    function textForValue(sel) {
      const opt = sel.selectedOptions[0] || sel.options[0];
      const image = opt.dataset.image;
      const text = opt ? opt.textContent : '';
      if (image != undefined) {
        return '<img src="' + image + '" alt="' + text + '" width="20" height="20" loading="lazy">\
        <span>' + text + '</span>'
      }
      return text;
    }

    function nextEnabled(from, dir) {
      let i = optionEls.indexOf(from);
      do { i = (i + dir + optionEls.length) % optionEls.length; }
      while (optionEls[i] && optionEls[i].getAttribute('aria-disabled') === 'true');
      return optionEls[i] || null;
    }

    button.addEventListener('click', () => {
      if (listbox.hidden) openList(); else closeList({ returnFocus: true });
    });

    button.addEventListener('keydown', (e) => {
      switch (e.key) {
        case 'ArrowDown':
        case 'Down':
          e.preventDefault();
          openList();
        break;
        case 'ArrowUp':
        case 'Up':
          e.preventDefault();
          openList();
        break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          openList();
        break;
        case 'Escape':
          e.preventDefault();
          closeList({ returnFocus: true });
        break;
      }
    });

    listbox.addEventListener('keydown', (e) => {
      const active = document.activeElement.closest('.c-select__option');
      if (!active) return;

      if (e.key === 'ArrowDown' || e.key === 'Down') {
        e.preventDefault();
        nextEnabled(active, +1)?.focus();
      } else if (e.key === 'ArrowUp' || e.key === 'Up') {
        e.preventDefault();
        nextEnabled(active, -1)?.focus();
      } else if (e.key === 'Home') {
        e.preventDefault();
        (optionEls.find(li => li.getAttribute('aria-disabled') !== 'true') || active).focus();
      } else if (e.key === 'End') {
        e.preventDefault();
        [...optionEls].reverse().find(li => li.getAttribute('aria-disabled') !== 'true')?.focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const value = active.dataset.value;
        if (active.getAttribute('aria-disabled') !== 'true') selectValue(value, { focusButton: true });
      } else if (e.key === 'Escape') {
        e.preventDefault();
        closeList({ returnFocus: true });
      } else if (e.key === 'Tab') {
        closeList({ returnFocus: false });
      }
    });

    function onDocClick(e) {
      if (!wrapper.contains(e.target)) closeList({ returnFocus: false });
    }
    function onDocFocusOut(e) {
      if (!wrapper.contains(e.target)) closeList({ returnFocus: false });
    }

    let typeBuffer = '';
    let typeTimer = null;
    function onDocTypeahead(e) {
      if (listbox.hidden) return;
      const char = e.key.length === 1 ? e.key : '';
      if (!char || /\s/.test(char)) return;

      typeBuffer += char.toLowerCase();
      clearTimeout(typeTimer);
      typeTimer = setTimeout(() => (typeBuffer = ''), 600);

      const match = optionEls.find(li =>
        li.getAttribute('aria-disabled') !== 'true' &&
        li.textContent.trim().toLowerCase().startsWith(typeBuffer)
      );
      if (match) match.focus();
    }

    nativeSelect.addEventListener('change', () => {
      const val = nativeSelect.value;
      optionEls.forEach(li => li.setAttribute('aria-selected', String(li.dataset.value === val)));
      btnText.innerHTML = textForValue(nativeSelect);

      if (selects.length > 0) {
        const selectedOptions = [];

        selects.forEach((select) => {
        selectedOptions.push(select.value);
        });

        if (productFormOptions.length > 0) {
        productFormOptions.forEach((productFormOption) => {
          if (selectedOptions.includes(productFormOption.value) && productFormOption.checked == false) {
          productFormOption.checked = true;
          productFormOption.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        }

        mobileOptions.forEach((mobileOption) => {
        if (selectedOptions.includes(mobileOption.value) && mobileOption.checked == false) {
          mobileOption.checked = true;
          mobileOption.dispatchEvent(new Event('change', { bubbles: true }));
        }
        });

        variants.forEach((variant) => {
        if (isEqual(variant.options, selectedOptions)) {
          variant_id.value = variant.id;

          const featured_media = variant.featured_media;
          if (featured_media != undefined) {
            const media = image.querySelector('img[data-id="' + featured_media.id + '"]');
            if (media != null) {
              image.querySelector('img:not(.hidden)').classList.add('hidden');
              media.classList.remove('hidden');

              mobileImage.querySelector('img:not(.hidden)').classList.add('hidden');
              mobileImage.querySelector('img[data-id="' + featured_media.id + '"]').classList.remove('hidden');
            }
          }

          if (variant.available == true) {
            btn.disabled = false;
            // btnContent.innerHTML = window.variantStrings.addToCart + ' - <span>' + Shopify.formatMoney(variant.price, 'amount_no_decimals') + '</span>';
            btnContent.innerHTML = window.variantStrings.addToCart;
          } else {
            btn.disabled = true;
            btnContent.innerText = window.variantStrings.soldOut;
          }
        }
        });
      }
    });
  }
})();
